// bao migrate skip

// bao migrate - module not found: import ISubProjectResourceModel from "view-models/dialogs/isub-project-resource-model";
import "./../../bindings/bao-searcher";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import BaoDialog from "./../../factories/bao-dialog";
class SubProjectResourceDialog implements ISubProjectResourceDialog {
    Dialog: BaoDialog = new BaoDialog(Bao.Session.ApplicationName);
    DialogResult: KnockoutObservable<boolean> = this.Dialog.DialogResult;
    SessionTabId: string;
    CustomerId: KnockoutObservable<string> = ko.observable(null);
    QualificationId: KnockoutObservable<string> = ko.observable(null);
    ProjectId: string;
    SubProjectId: string;
    ConfigurationItem250QualificationId: string;
    ConfigurationItem250ResourceId: string;
    constructor(sessionTabId: string, customerId: string, qualificationId: string, projectId: string, subProjectId: string, configurationItem250QualificationId: string, configurationItem250ResourceId: string) {
        this.Dialog.Width("600px");
        this.Dialog.Buttons([
            new BaoDialog.ButtonFactory(this.Dialog, Bao.Session.GetMessage("msgOk"), $.proxy(this.OkClick, this)),
            new BaoDialog.ButtonFactory(this.Dialog, Bao.Session.GetMessage("msgCancel"), $.proxy(this.CancelClick, this))
        ]);
        this.SessionTabId = sessionTabId;
        this.CustomerId(customerId);
        this.QualificationId(qualificationId);
        this.ProjectId = projectId;
        this.SubProjectId = subProjectId;
        this.ConfigurationItem250QualificationId = configurationItem250QualificationId;
        this.ConfigurationItem250ResourceId = configurationItem250ResourceId;
    }
    Open() {
        var self = this;
        Bao.post("ConfigurationItemTab/ShowConfigurationItemSubProjectResourceDialog", JSON.stringify({
            sessionTabId: self.SessionTabId,
            parentConfigurationItemId: self.ProjectId,
            configurationItemId: self.SubProjectId,
            configurationItem250QualificationId: self.ConfigurationItem250QualificationId,
            configurationItem250ResourceId: self.ConfigurationItem250ResourceId
        }), function (value) {
            self.Dialog.ViewModel(ko.map.fromJS(value.Model));
            self.Dialog.ViewModel().Focus = function () { };
            self.Dialog.ViewModel().FilterId = ko.observable();
            self.Dialog.ViewModel().FilterId(self.CustomerId);
            self.Dialog.ViewModel().QualificationId = ko.observable();
            self.Dialog.ViewModel().QualificationId(self.QualificationId());
            self.Dialog.Template(value.Message);
            self.Dialog.Open(null);
            self.Dialog.ViewModel().Focus();
        });
    }
    OkClick(): void {
        if (this.CompleteCheck() == true) {
            this.AddResource(this.Dialog.ViewModel()).then(() => {
                this.DialogResult(true);
                this.Dialog.Close();
            });
        }
    }
    AddResource(model: ISubProjectResourceModel): JQueryPromise<void> {
        var self = this;
        this.Dialog.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AddConfigurationItemSubProjectResource", JSON.stringify({
            sessionTabId: self.SessionTabId,
            parentConfigurationItemId: self.ProjectId,
            configurationItemId: self.SubProjectId,
            configurationItem250QualificationId: self.ConfigurationItem250QualificationId,
            resourceModel: ko.map.toJS(model)
        }));
    }
    ;
    CancelClick(): void {
        this.DialogResult(false);
        this.Dialog.Close();
    }
    CompleteCheck(): boolean {
        var isComplete: boolean = true;
        if (this.Dialog.ViewModel().PersonId() == null) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
}
export default SubProjectResourceDialog;

interface ISubProjectResourceDialogStatic {
    new (sessionTabId: string, customerId: string, qualificationId: string, projectId: string, subProjectId: string, configurationItem250ResourceId: string): ISubProjectResourceDialog;
}

interface ISubProjectResourceDialog {
    Dialog: BaoDialog;
    DialogResult: KnockoutObservable<boolean>;

    SessionTabId: string;
    CustomerId: KnockoutObservable<string>;
    QualificationId: KnockoutObservable<string>;
    ProjectId: string;
    SubProjectId: string;
    ConfigurationItem250ResourceId: string;

    Open: () => void;
    OkClick: () => void;
    CancelClick: () => void;
}

interface ISubProjectResourceModel {
    ConfigurationItem250ResourceId: KnockoutObservable<string>;
}